export const resloveStatus = (status: string) => {
  switch (status) {
    case 'active':
      return 'Aktiv'

    default:
      return 'Ukjent status'
  }
}
